import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { CloseIcon } from "../icons";
import { Button } from "../Button";
import { Text } from "../Text";
import { useTimeoutClick } from "./hooks/useTimeoutClick";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Notification = /*#__PURE__*/memo(function (_ref) {
  var _cn, _cn2;
  var _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Notification' : _ref$testName,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'id' : _ref$id,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    duration = _ref.duration,
    text = _ref.text,
    buttonText = _ref.buttonText,
    href = _ref.href,
    isWithCloseButton = _ref.isWithCloseButton,
    variant = _ref.variant,
    shape = _ref.shape,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target;
  var _useTimeoutClick = useTimeoutClick({
      duration: duration,
      onClick: onClick,
      id: id
    }),
    handleOnClick = _useTimeoutClick.handleOnClick;
  var Tag = href ? 'a' : 'button';
  var extraAttributes = useMemo(function () {
    var finalAttributes = {};
    if (href) {
      finalAttributes = {
        target: target,
        href: href,
        rel: target === '_blank' ? 'nofollow noopener' : undefined
      };
    } else {
      finalAttributes = {
        type: 'button'
      };
    }
    return finalAttributes;
  }, [href, target]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('notification-item-wrapper'),
    "data-t-id": "src-Notification"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('notification-item', (_cn = {}, _defineProperty(_cn, "notification-item--".concat(variant), !!variant), _defineProperty(_cn, 'notification-item--plain', !buttonText), _defineProperty(_cn, "notification-item--".concat(shape), !!shape), _defineProperty(_cn, "notification-item--plain--".concat(shape), !buttonText && !!shape), _cn)),
    "data-component": testName
  }, /*#__PURE__*/React.createElement(Text, {
    color: variant === 'secondary' ? 'textIconElementPrimary' : 'textIconElementPrimaryInvert',
    size: "size5-r-s"
  }, text), isWithCloseButton && /*#__PURE__*/React.createElement("div", {
    className: cn('notification-item__close')
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(CloseIcon, {
      size: 20
    }),
    onClick: handleOnClick,
    variant: "plain"
  }))), buttonText && /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn('notification-item__button', (_cn2 = {}, _defineProperty(_cn2, "notification-item__button--".concat(variant), !!variant), _defineProperty(_cn2, "notification-item__button--".concat(shape), !!shape), _cn2)),
    onClick: handleOnClick
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, extraAttributes), buttonText));
});
Notification.displayName = Notification.name;